import React, { useState } from 'react';
import CanonicalTag from '../components/CanonicalTag';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Thank you for contacting us! We will respond to your message shortly.');
    setFormData({
      name: '',
      email: '',
      subject: '',
      message: ''
    });
  };

  return (
    <div>
      <CanonicalTag />
      <div className="page-header">
        <div className="container">
          <h1>Contact Us</h1>
          <p>We're here to help — get in touch today</p>
        </div>
      </div>

      <section className="page-section">
        <div className="container">
          <div className="content-section">
            <span className="section-label">Reach Out</span>
            <h2>Connect With Udugiri Infratech</h2>
            <p>
              We value open communication and are committed to providing prompt, helpful responses to all inquiries. 
              Whether you have questions about our services, need technical support, want to discuss a potential 
              project, or simply wish to learn more about Udugiri Infratech, our team is ready to assist you.
            </p>
            <p>
              Choose the communication method that works best for you, and we'll ensure your message reaches the 
              right person who can provide the information or assistance you need.
            </p>
          </div>

          <div className="content-section">
            <span className="section-label">Find Us</span>
            <h2>Contact Information</h2>
            <div className="contact-info-grid">
              <div className="contact-info-card">
                <div className="contact-card-icon">🏢</div>
                <h3>Corporate Office</h3>
                <address>
                  Udugiri Infratech<br />
                  #196, 1st Cross Link Road<br />
                  Malleshwaram, Bangalore – 560003<br />
                  India
                </address>
                <div className="gst-badge">
                  <span className="gst-label">GST</span>
                  <span className="gst-number">29CAHPR7591G1ZZ</span>
                </div>
              </div>
              <div className="contact-info-card">
                <div className="contact-card-icon">📧</div>
                <h3>Email</h3>
                <a href="mailto:udugiriengineer@gmail.com">udugiriengineer@gmail.com</a>
              </div>
              <div className="contact-info-card">
                <div className="contact-card-icon">📞</div>
                <h3>Phone</h3>
                <a href="tel:+917899213066">+91 78992 13066</a>
                <a href="tel:+919731981092">+91 97319 81092</a>
              </div>
              <div className="contact-info-card">
                <div className="contact-card-icon">🕐</div>
                <h3>Business Hours</h3>
                <div className="hours-row"><span>Mon – Fri</span><span>9:00 AM – 6:00 PM</span></div>
                <div className="hours-row"><span>Saturday</span><span>9:00 AM – 1:00 PM</span></div>
                <div className="hours-row"><span>Sunday</span><span className="closed">Closed</span></div>
              </div>
            </div>
          </div>

          <div className="content-section">
            <h2>Department-Specific Contacts</h2>
            <p>For all inquiries — project coordination, technical support, business partnerships, or media — reach us at:</p>
            <p><strong>📧 udugiriengineer@gmail.com</strong></p>
            <p><strong>📞 +91 78992 13066 / +91 97319 81092</strong></p>
          </div>

          <div className="form-container">
            <h2>Send Us a Message</h2>
            <p>Use the form below to send us a direct message. We typically respond within 24-48 hours.</p>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">Your Name *</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Your Email *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="subject">Subject *</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="message">Your Message *</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Please provide details about your inquiry..."
                  required
                ></textarea>
              </div>

              <button type="submit" className="submit-button">
                Send Message
              </button>
            </form>
          </div>

          <div className="content-section">
            <h2>Visit Our Office</h2>
            <p>
              We welcome clients, partners, and prospective employees to visit our office. To ensure someone is 
              available to meet with you and provide the attention your visit deserves, we recommend scheduling an 
              appointment in advance by calling us or sending an email with your preferred date and time.
            </p>
            <p>
              Our office is equipped with meeting facilities where we can discuss your requirements in detail, 
              demonstrate our capabilities, and provide comprehensive information about our services and solutions.
            </p>
          </div>

          <div className="content-section">
            <h2>Response Time and Communication</h2>
            <p>
              At Udugiri Infratech, we prioritize timely communication. Here's what you can expect:
            </p>
            <ul>
              <li><strong>Email Inquiries:</strong> Responses typically within 24-48 business hours</li>
              <li><strong>Phone Calls:</strong> Immediate assistance during business hours; voicemail messages returned within 24 hours</li>
              <li><strong>Contact Form Submissions:</strong> Acknowledgment within 24 hours, detailed response within 48 hours</li>
              <li><strong>Urgent Matters:</strong> For time-sensitive issues, please call directly and mention the urgency</li>
            </ul>
          </div>

          <div className="content-section">
            <h2>Social Media</h2>
            <p>
              Stay connected with Udugiri Infratech through our social media channels for updates, industry insights, 
              and company news:
            </p>
            <ul>
              <li><strong>LinkedIn:</strong> [Company LinkedIn Profile]</li>
              <li><strong>Facebook:</strong> [Company Facebook Page]</li>
              <li><strong>Twitter:</strong> [Company Twitter Handle]</li>
            </ul>
          </div>

          <div className="content-section">
            <h2>Feedback and Suggestions</h2>
            <p>
              We continuously strive to improve our services and client experience. If you have feedback, suggestions, 
              or testimonials about your experience working with Udugiri Infratech, we'd love to hear from you. 
              Please send your thoughts to <strong>udugiriengineer@gmail.com</strong>
            </p>
          </div>

          <div className="content-section">
            <h2>Privacy and Data Protection</h2>
            <p>
              All information shared through our contact channels is treated with strict confidentiality and used 
              solely for the purpose of responding to your inquiry or request. We do not share personal information 
              with third parties without explicit consent. For more details, please refer to our Privacy Policy.
            </p>
          </div>
        </div>
      </section>

      <div className="map-strip">
        <div className="map-strip-header">
          <span className="section-label">Find Us</span>
          <h2>Our Location</h2>
        </div>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3219.4568189137576!2d77.5739408!3d12.994480999999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae173f5bd5a32b%3A0x271b7da92608391b!2sManasvi%20Events!5e1!3m2!1sen!2sin!4v1783843046348!5m2!1sen!2sin"
          width="100%"
          height="480"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="strict-origin-when-cross-origin"
          title="Udugiri Infratech Location"
        ></iframe>
      </div>
    </div>
  );
}

export default Contact;
